import React, { FC } from 'react';
import { formatTime, getSimpleDateFormat, getUserName } from 'utils/functions';
import './styles.scss';
import { ReactComponent as UserIcon } from 'assets/icons/user.svg';
import { ReactComponent as ClockIcon } from 'assets/icons/clock.svg';
import { Button } from '@cokitchen/cokitchen-components';
import { ReactComponent as MailIcon } from 'assets/icons/sms.svg';
import { ReactComponent as PhoneIcon } from 'assets/icons/call.svg';
import { UserType } from 'models/user.model';
import CopyText from 'components/base/copy-text';

type Props = {
  users: UserType[];
  onSelect: (user: UserType) => void;
};

const UserResultMobile: FC<Props> = ({ users, onSelect }) => {
  return (
    <div className='grid md:grid-cols-2 lg:grid-cols-3 gap-4'>
      {users.map((user) => (
        <div key={user.id} className='cursor-pointer live-trip-card relative'>
          <div className='flex flex-col gap-2 px-4 pb-3 grow'>
            <div className='flex items-center gap-2'>
              <UserIcon className='w-4 h-4' />
              <h4 className='font-medium  text-base text-gray-6'>{getUserName(user)}</h4>
            </div>
            <div className='flex gap-2 flex-wrap'>
              <div className='grow'>
                <div className='flex justify-start items-center mb-1'>
                  <MailIcon />
                  <p className='mx-3 text-sm text-[#858585]'>{user.email}</p>
                </div>
                <div className='inline-flex justify-start items-center'>
                  <PhoneIcon />
                  <CopyText className='mx-3 text-sm text-[#858585]' text={user.phone_number} />
                </div>
              </div>
              <div className='text-sm'>
                <div className='mb-1'>
                  <span>Bani Acct: </span>
                  {user?.bani_account_number || (
                    <div className='text-[10px] leading-[19px] inline-flex justify-center bg-[#F0F0F0] border border-1 border-[#DEDEDE] text-[#858585] px-1 rounded-sm'>
                      N/A
                    </div>
                  )}
                </div>
                <div>
                  <span>Providus Acct: </span>
                  {user?.bani_account_number_providus || (
                    <div className='text-[10px] leading-[19px] inline-flex justify-center bg-[#F0F0F0] border border-1 border-[#DEDEDE] text-[#858585] px-1 rounded-sm'>
                      N/A
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className='border-t border-gray-border text-xs p-4 flex justify-between items-center'>
            <div className='flex items-center gap-2'>
              <ClockIcon />
              <div className='flex items-center gap-2'>
                {getSimpleDateFormat(user.created_at)}
                <div className='bg-gray-2 min-w-[8px] w-2 h-2 rounded-full'></div>
                {formatTime(user.created_at)}
              </div>
            </div>
            <Button
              color='primary'
              variant='link'
              className='text-sm'
              onClick={() => onSelect(user)}>
              View details
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default UserResultMobile;
